module.exports = __webpack_public_path__ + "img/counter-checkmark.be35361a.svg";